<template>
  <p :class="$style.selection">{{ selection }}</p>
</template>

<script setup lang="ts">
defineProps<{
  selection: string
}>()
</script>

<style lang="scss" module>
.selection {
  display: inline-block;
  padding: 8px 12px;
  background-color: $color-surface-secondary;
  border-radius: 4px;
}
</style>
